import React, { useEffect } from 'react';
import {
  Switch, BrowserRouter as Router, Route, useHistory,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import jwtDecode from 'jwt-decode';
// import { toast } from 'react-toastify';
// import { useTranslation } from 'react-i18next';

// layouts Format
import AuthLayout from 'Layout/AuthLayout';
import ForgotPassword from 'pages/Authentication/ForgotPassword';
import Login from 'pages/Authentication/Login';
import Pages404 from 'pages/PageErrors/Page404';

import Register from 'pages/Authentication/Register';
import ResetPassword from 'pages/Authentication/ResetPassword';
import CreatePassword from 'pages/Authentication/CreatePassword';
import { TermsOfUse, OperatingRules } from 'pages/LegalDocuments';
import ScrollToTop from 'components/ScrollToTop';

import { LOCATIONS, storageKey, LOGIN_TYPE } from 'constants/index';

import INITIAL_VALUE from 'constants/initialValue';
import propTypeModels from 'propTypeModels';
import AuthMiddleware from 'routes/route';
import { authProtectedRoutes } from 'routes';
import axiosClient from 'utils/axios';
import { connectSocket, disconnectSocket } from 'utils/socket';

// Import scss
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'assets/scss/theme.scss';
import 'App/styles.scss';
import 'App/theme-override.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';
import AuthExtranetLayout from 'Layout/AuthExtranetLayout/AuthExtranetLayout';

const App = (props) => {
  const {
    me,

    actionGetMe,
    actionGetSetting,

    isLoggedIn,
    isLoadingGetMyPermission,
    myPermission,
    actionGetMyPermission,
  } = props;

  const history = useHistory();
  // const { t } = useTranslation();

  // const refreshAccessToken = localStorage.getItem(storageKey.AUTHENTICATE_REFRESH_TOKEN);
  const accessToken = localStorage.getItem(storageKey.AUTHENTICATE_TOKEN);

  const loginType = process.env.REACT_APP_LOGIN_TYPE;

  if (accessToken) {
    axiosClient.defaults.headers.Authorization = `Bearer ${accessToken}`;

    // phần này cần làm việc với back-end về việc bảo mật token khi axios request

    // axiosClient.interceptors.request.use((config) => {
    //   const { origin } = new URL(config.baseURL);
    //   const allowedOrigins = [process.env.REACT_APP_BASE_URL];

    //   if (allowedOrigins.includes[origin]) {
    //     // eslint-disable-next-line no-param-reassign
    //     config.headers.authorization = accessToken;
    //   }

    //   return config;
    // }, (error) => Promise.reject(error));
  }

  // check refresh Token
  // useEffect(() => {
  //   if (me._id) {
  //     // Check refresh token
  //     try {
  //       const currentDate = (Date.now() / 1000);
  //       const checkToken = jwtDecode(accessToken).exp;
  //       const checkRefreshToken = jwtDecode(refreshAccessToken).exp;

  //       if ((checkToken < currentDate) && (checkRefreshToken < currentDate)) {
  //         localStorage.removeItem(storageKey.AUTHENTICATE_TOKEN);
  //         localStorage.removeItem(storageKey.AUTHENTICATE_REFRESH_TOKEN);
  //         return null;
  //       }
  //       if (checkToken < currentDate) {
  //         if (checkRefreshToken > currentDate) {
  //           actionRefreshTokenSuccess({ refreshAccessToken });
  //         }
  //       }
  //     } catch (error) {
  //       localStorage.removeItem(storageKey.AUTHENTICATE_TOKEN);
  //       localStorage.removeItem(storageKey.AUTHENTICATE_REFRESH_TOKEN);
  //       actionRefreshTokenFailed();
  //       toast.error(t('error.wrong_format'));
  //     }
  //   }
  //   return undefined;
  // }, [me._id]);

  useEffect(() => {
    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);
        // eslint-disable-next-line no-console
        if (decoded && typeof decoded.isIntranet === 'boolean') {
          const tokenLoginType = decoded.isIntranet ? LOGIN_TYPE.INTRANET : LOGIN_TYPE.EXTRANET;
          localStorage.setItem(storageKey.LOGIN_TYPE, tokenLoginType);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
      }
    }
  }, [accessToken]);

  useEffect(() => {
    let cleanup = () => {};

    if (!accessToken) {
      disconnectSocket();
      return cleanup;
    }

    const socket = connectSocket();

    const onConnect = () => {
      socket.emit('subscribe', { token: accessToken });
    };

    socket.on('connect', onConnect);

    if (socket.connected) {
      onConnect();
    }

    cleanup = () => {
      socket.off('connect', onConnect);
    };

    return cleanup;
  }, [accessToken]);

  useEffect(() => {
    const token = localStorage.getItem(storageKey.AUTHENTICATE_TOKEN);
    if (!token) {
      return undefined;
    }

    actionGetMe({ history });
    return undefined;
  }, [isLoggedIn, accessToken]);

  useEffect(() => {
    if (me._id) {
      actionGetSetting();

      actionGetMyPermission();
    }
  }, [me]);

  return (
    <>
      <ScrollToTop />

      <Router>
        <Switch>
          <Route path={LOCATIONS.LOGIN} component={Login} />
          <Route path={LOCATIONS.REGISTER} component={Register} />

          <Route path={LOCATIONS.FORGOT_PASSWORD} component={ForgotPassword} />
          <Route path={LOCATIONS.RESET_PASSWORD} component={ResetPassword} />
          <Route path={LOCATIONS.CREATE_PASSWORD} component={CreatePassword} />
          <Route path={LOCATIONS.TERMS_OF_USE} component={TermsOfUse} exact />
          <Route path={LOCATIONS.OPERATING_RULES} component={OperatingRules} exact />

          {authProtectedRoutes.map((route) => (
            <AuthMiddleware
              path={route.path}
              layout={loginType === LOGIN_TYPE.EXTRANET ? AuthExtranetLayout : AuthLayout}
              component={route.component}
              key={route.path}
              exact={route.exact}
              isLoadingGetMyPermission={isLoadingGetMyPermission}
              myPermission={myPermission}
              loginTypes={route.loginTypes}
            />
          ))}

          <Route component={Pages404} key="not-found" />
        </Switch>
      </Router>
    </>
  );
};

App.propTypes = {
  me: propTypeModels.user.userPropTypes.isRequired,

  actionGetMe: PropTypes.func,
  actionGetSetting: PropTypes.func,
  // actionRefreshTokenSuccess: PropTypes.func,
  // actionRefreshTokenFailed: PropTypes.func.isRequired,

  isLoggedIn: PropTypes.bool,
  isLoadingGetMyPermission: PropTypes.bool.isRequired,
  myPermission: PropTypes.instanceOf(Object).isRequired,
  actionGetMyPermission: PropTypes.func.isRequired,
};

App.defaultProps = {
  actionGetMe: INITIAL_VALUE.FUNCTION,
  actionGetSetting: INITIAL_VALUE.FUNCTION,
  isLoggedIn: false,
  // actionRefreshTokenSuccess: () => {},
};

export default App;
